var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleColorPicker = function SvgSimpleColorPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 3.333,
    r: 3.333,
    fill: "#59A315"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12.667,
    r: 3.333,
    fill: "#FDCE00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.667,
    cy: 8,
    r: 3.333,
    fill: "#EB0C3B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.333,
    cy: 8,
    r: 3.333,
    fill: "#0E72ED"
  })));
};
export { SvgSimpleColorPicker as ReactComponent };
export default __webpack_public_path__ + "fonts/simple-color-picker-32d30b97fe686e82221aa5e16d6724fd.svg";